// THE WORKSPACE OR ITS CLI — one switch, "Workspace · CLI"
// (functions/workspaceMode.js; Nika 2026-10-23: "add switcher so we can switch
// between normal and CLI-like workspace easily"). The same switch in both
// shells: at the top of the home (components/HomeViewSwitch.js) and in the
// Agent frame's header (components/AgentModeFrame.js) — the kit's view switch
// (AppSegmented variant 'view'), no look of its own. Ctrl+` flips it.
export const WorkspaceModeSwitch = {
  class: 'workspace-mode-switch',
  dataWorkspaceMode: true,
  display: 'flex',
  minWidth: '0',
  flexShrink: '0',
  subscribeTo: ['agentMode', '_agentModeLink', 'signedIn', '_homeCustomizeMode'],
  hide: (el, s) => !el.call('workspaceModeShown', s.root),
  title: (el) => el.call('polyglot', 'workspace.agentMode.toggle'),
  AppSegmented: {
    variant: 'view',
    ariaLabel: (el) => el.call('polyglot', 'workspace.agentMode.switchLabel'),
    current: (el, s) => el.call('workspaceModeOf', s.root),
    select: 'workspaceModeSelect',
    childrenAs: 'state',
    children: (el) => el.call('workspaceModeSegments')
  }
}
